import { createSlice } from "@reduxjs/toolkit";
import { fetchSalesOrderRecord } from "./SalesOrderRecordThunk";

const initialState = {
  list: [],
  loading: false,
  
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null, // 👈 separate field
    toDate: null,
  },
};

const salesOrderRecordSlice = createSlice({
  name: "salesOrderRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesOrderRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSalesOrderRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchSalesOrderRecord.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = salesOrderRecordSlice.actions;
export default salesOrderRecordSlice.reducer;
